import { Directive, Input, OnChanges, OnDestroy, OnInit, Optional, SimpleChanges } from '@angular/core';
import { FormGroupDirective, UntypedFormGroup } from '@angular/forms';
import { resetFormDirtyStatus, setFormDirtyStatus } from '@app/core/leave-page-handler/actions/leave-page';
import { ActionsSubject } from '@ngrx/store';
import { takeOne } from '@util';
import * as R from 'ramda';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

/**
 * <p> Directive that get {@link UntypedFormGroup} and listen for change of dirty status of the form.
 * <p> In case of change dispatch {@link SetFormDirtyStatus(true)} action and update the state in LeavePageState.
 * <p> On submit dispatch {@link SetFormDirtyStatus(false)} action and update the state in LeavePageState.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[formGroup]'
})
export class PcsFormGroupDirective implements OnInit, OnChanges, OnDestroy {

  @Input() formGroup: UntypedFormGroup;
  subscriptions: Subscription[] = [];

  constructor(private actions: ActionsSubject, @Optional() private control: FormGroupDirective) {
    this.actions.next(resetFormDirtyStatus());
  }

  ngOnInit() {
    this.subscriptions.push(
      this.control.ngSubmit.subscribe(() => this.actions.next(resetFormDirtyStatus()))
    );
  }

  ngOnDestroy() {
    R.forEach((subscription: Subscription) => subscription.unsubscribe(), this.subscriptions);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // TODO: Remove filter once the issue with on validator change is solved: https://github.com/angular/angular/issues/25749
    this.subscriptions.push(
      this.formGroup.valueChanges
        .pipe(
          filter(_ => this.formGroup.dirty),
          takeOne()
        ).subscribe(() => {
          this.actions.next(setFormDirtyStatus());
        })
    );
  }
}
